<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">All Branches</h1>
          </div>
          <div class="col-sm-2">
            <router-link v-if="hasPermission('branch create')" style="margin-right: 10px" class="btn btn-primary"
              :to="{ name: 'create-branche' }">create</router-link>
            <router-link v-if="hasPermission('branch getSoftDeleted')" class="btn btn-success"
              :to="{ name: 'deleted-branches' }">Deleted
              branches</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">
            <h5 class="over-title margin-bottom-15">
            </h5>
            <p>

            </p>
            <div v-if="branches.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(branche, index) in filteredBranches" :key="index">
                  <th scope="row">{{ branche.id }}</th>
                  <td>{{ branche.name_ar }}</td>
                  <td>{{ branche.name_en }}</td>
                  <td>
                    <button class="me-2 btn btn-danger" v-if="hasPermission('branch delete')"
                      @click="deleteBranche(branche.id)">
                      Delete
                    </button>
                    <router-link class="btn btn-primary spacing" v-if="hasPermission('branch update')"
                      :to="{ name: 'edit-branche', params: { id: branche.id } }">
                      Edit
                    </router-link>
                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No branches found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import $ from 'jquery'; // Import jQuery
import { store } from "../../Store";
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component
import axios from "../../Axios";
export default {
  name: "AllBranches",
  components: {
    MyTable,
    // Paginate,
  },
  data() {
    return {
      dataTable: [],
      branches: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name Arabic', key: 'name_ar' },
        { label: 'Name English', key: 'name_en' },
      ],
    };
  },

  async created() {
    this.fetchBranches();
  },

  computed: {
    hasPermission() {
      return (permission) => store.hasPermission(permission);
    },
    filteredBranches() {
      if (!this.searchTerm) {
        return this.branches;
      }
      const term = this.searchTerm.toLowerCase();
      return this.branches.filter((branche) =>
        branche.name.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch cities
    async fetchBranches() {
      try {
        const response = await axios.get(
          // `/admin/admin/branch/all?page=${page}&is_paginate=15`
          `/admin/admin/branch/all`
        );
        this.branches = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching categoris:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    deleteBranche(id) {
      console.log("delete branche id: ", id);
      axios
        .delete(`/admin/admin/branch/delete?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchBranches();
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
};
</script>


<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>
